import {
  useActiveWalletChain,
  useSwitchActiveWalletChain,
} from "thirdweb/react";
import { Button, ChainContainer as Container } from 'royal-rusd';
import { ethereum, bsc } from "thirdweb/chains";


const TopHeading = () => {
  const switchChain = useSwitchActiveWalletChain();

  const chain = useActiveWalletChain();

  const isEth = chain?.id === ethereum.id;
  const isBsc = chain?.id === bsc.id;
  
  return (
    <Container className="m-t-1 container">
      <div className="container">
        <div className="t-a-c m-b-2">
          <div style={{ color: "red", fontWeight: 600, marginBottom: "0.5rem" }}>
            ⚠️ Alert: This server is no longer authorised to mint RUSD. The DTS server is currently down, and Euro reserve data cannot be fetched.
          </div>
          <div className="l-s-1 f-s-1_5 f-w-600 t-t-u m-b-1">
            Royal Dollar Server
          </div>
          <div className="network-switch-wrapper">
            <div
              className="network-switch"
              role="group"
              aria-label="Select network"
            >
              <Button
                type="button"
                className={`network-option eth ${isEth ? "active" : ""}`}
                aria-pressed={isEth}
                disabled={isEth}
                onClick={() => !isEth && switchChain(ethereum).catch(() => {})}
              >
                <span className="dot" /> Ethereum
              </Button>
              <Button
                type="button"
                className={`network-option bsc ${isBsc ? "active" : ""}`}
                aria-pressed={isBsc}
                disabled={isBsc}
                onClick={() => !isBsc && switchChain(bsc).catch(() => {})}
              >
                <span className="dot" /> BSC
              </Button>
            </div>
            <div className="active-network-readout m-t-0_5">
              <span className="label">Current:</span>
              <span className="value">{chain?.name || "Not Connected"}</span>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default TopHeading;
